
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8","fill":"#282828"}},[_c('path',{attrs:{"d":"M6 0H2a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V2a2 2 0 00-2-2zM16 0h-4a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V2a2 2 0 00-2-2zM6 10H2a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2zM14 18a4 4 0 100-8 4 4 0 000 8z"}})])])
          )
        }
      }
    